import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, ...props }) => {
  return icon
    ? React.createElement(icon, props)
    : <FiAlertTriangle {...props} />;
};

export default SafeIcon;